export const translations = {
  en: {
    home: "Home",
    about: "About",
    projects: "Projects",
    resources: "Resources",
    contact: "Contact",
    docs: "Documentation",
    inviteManager: "Invite Manager",
    templateBot: "Template Bot",
    multipurposeBot: "Multipurpose Bot",
    connect: "Connect",
    
    intro: "Frontend Developer & Engineer",
    available: "Available",
    mainHeadline: "Building Premium",
    typingEffect: "Digital Experiences",
    subHeadline: "Specialized in crafting scalable Discord bots, modern web applications, and comprehensive technical documentation.",
    viewProjects: "View Projects",
    viewDocs: "Documentation",
    
    aboutTitle: "About Me",
    aboutSubtitle: "Developer, Engineer, Documentation Writer",
    
    projectsTitle: "Featured Projects",
    projectsSubtitle: "Production-ready bots and web applications",
    
    resourcesTitle: "Learning Resources",
    resourcesSubtitle: "Curated guides and documentation",
    
    contactTitle: "Contact & Inquiries",
    contactSubtitle: "Let's discuss scalable systems, bot architecture, or coffee.",
    getInTouch: "Get in Touch",
    getInTouchDesc: "I'm currently open for Data Science, Backend Engineering, or Full-stack opportunities. Whether you have a question about my documentation or want to collaborate, feel free to reach out.",
    email: "Email",
    primaryContact: "Primary Contact",
    discord: "Discord",
    fastResponse: "Fast Response",
    github: "GitHub",
    codebase: "Codebase",
    clickHere: "Click Here",
    
    copyrightText: "Built with React + Parcel. All Rights Reserved.",
    privacyPolicy: "Privacy Policy",
    terms: "Terms of Service",
    
    previous: "Previous",
    next: "Next",
  },
  
  id: {
    home: "Beranda",
    about: "Tentang",
    projects: "Proyek",
    resources: "Sumber Daya",
    contact: "Kontak",
    docs: "Dokumentasi",
    inviteManager: "Invite Manager",
    templateBot: "Template Bot",
    multipurposeBot: "Multipurpose Bot",
    connect: "Terhubung",
    
    intro: "Frontend Developer & Engineer",
    available: "Tersedia",
    mainHeadline: "Membangun Premium",
    typingEffect: "Pengalaman Digital",
    subHeadline: "Spesialisasi dalam membuat bot Discord yang skalabel, aplikasi web modern, dan dokumentasi teknis yang komprehensif.",
    viewProjects: "Lihat Proyek",
    viewDocs: "Dokumentasi",
    
    aboutTitle: "Tentang Saya",
    aboutSubtitle: "Developer, Engineer, Penulis Dokumentasi",
    
    projectsTitle: "Proyek Unggulan",
    projectsSubtitle: "Bot dan aplikasi web siap produksi",
    
    resourcesTitle: "Sumber Pembelajaran",
    resourcesSubtitle: "Panduan dan dokumentasi terkurasi",
    
    contactTitle: "Kontak & Pertanyaan",
    contactSubtitle: "Mari diskusikan sistem yang skalabel, arsitektur bot, atau kopi.",
    getInTouch: "Hubungi Saya",
    getInTouchDesc: "Saya saat ini terbuka untuk peluang Data Science, Backend Engineering, atau Full-stack. Apakah Anda memiliki pertanyaan tentang dokumentasi saya atau ingin berkolaborasi, jangan ragu untuk menghubungi.",
    email: "Email",
    primaryContact: "Kontak Utama",
    discord: "Discord",
    fastResponse: "Respon Cepat",
    github: "GitHub",
    codebase: "Codebase",
    clickHere: "Klik Di Sini",
    
    copyrightText: "Dibuat dengan React + Parcel. Hak Cipta Dilindungi.",
    privacyPolicy: "Kebijakan Privasi",
    terms: "Syarat Layanan",
    
    previous: "Sebelumnya",
    next: "Selanjutnya",
  },
  
  es: {
    home: "Inicio",
    about: "Acerca de",
    projects: "Proyectos",
    resources: "Recursos",
    contact: "Contacto",
    docs: "Documentación",
    inviteManager: "Invite Manager",
    templateBot: "Template Bot",
    multipurposeBot: "Multipurpose Bot",
    connect: "Conectar",
    
    intro: "Desarrollador Frontend & Ingeniero",
    available: "Disponible",
    mainHeadline: "Construyendo Premium",
    typingEffect: "Experiencias Digitales",
    subHeadline: "Especializado en crear bots de Discord escalables, aplicaciones web modernas y documentación técnica completa.",
    viewProjects: "Ver Proyectos",
    viewDocs: "Documentación",
    
    aboutTitle: "Sobre Mí",
    aboutSubtitle: "Desarrollador, Ingeniero, Escritor de Documentación",
    
    projectsTitle: "Proyectos Destacados",
    projectsSubtitle: "Bots y aplicaciones web listos para producción",
    
    resourcesTitle: "Recursos de Aprendizaje",
    resourcesSubtitle: "Guías y documentación curada",
    
    contactTitle: "Contacto y Consultas",
    contactSubtitle: "Hablemos de sistemas escalables, arquitectura de bots o café.",
    getInTouch: "Ponte en Contacto",
    getInTouchDesc: "Actualmente estoy abierto a oportunidades de Ciencia de Datos, Ingeniería Backend o Full-stack. Si tienes alguna pregunta sobre mi documentación o quieres colaborar, no dudes en contactarme.",
    email: "Correo",
    primaryContact: "Contacto Principal",
    discord: "Discord",
    fastResponse: "Respuesta Rápida",
    github: "GitHub",
    codebase: "Código",
    clickHere: "Haz Clic Aquí",
    
    copyrightText: "Creado con React + Parcel. Todos los Derechos Reservados.",
    privacyPolicy: "Política de Privacidad",
    terms: "Términos de Servicio",
    
    previous: "Anterior",
    next: "Siguiente",
  },
  
  it: {
    home: "Home",
    about: "Chi Sono",
    projects: "Progetti",
    resources: "Risorse",
    contact: "Contatto",
    docs: "Documentazione",
    inviteManager: "Invite Manager",
    templateBot: "Template Bot",
    multipurposeBot: "Multipurpose Bot",
    connect: "Connetti",
    
    intro: "Frontend Developer & Ingegnere",
    available: "Disponibile",
    mainHeadline: "Costruire Premium",
    typingEffect: "Esperienze Digitali",
    subHeadline: "Specializzato nella creazione di bot Discord scalabili, applicazioni web moderne e documentazione tecnica completa.",
    viewProjects: "Vedi Progetti",
    viewDocs: "Documentazione",
    
    aboutTitle: "Chi Sono",
    aboutSubtitle: "Sviluppatore, Ingegnere, Scrittore di Documentazione",
    
    projectsTitle: "Progetti in Evidenza",
    projectsSubtitle: "Bot e applicazioni web pronti per la produzione",
    
    resourcesTitle: "Risorse di Apprendimento",
    resourcesSubtitle: "Guide e documentazione curata",
    
    contactTitle: "Contatto e Richieste",
    contactSubtitle: "Parliamo di sistemi scalabili, architettura bot o caffè.",
    getInTouch: "Mettiti in Contatto",
    getInTouchDesc: "Attualmente sono aperto a opportunità di Data Science, Backend Engineering o Full-stack. Se hai domande sulla mia documentazione o vuoi collaborare, non esitare a contattarmi.",
    email: "Email",
    primaryContact: "Contatto Principale",
    discord: "Discord",
    fastResponse: "Risposta Rapida",
    github: "GitHub",
    codebase: "Codice",
    clickHere: "Clicca Qui",
    
    copyrightText: "Realizzato con React + Parcel. Tutti i Diritti Riservati.",
    privacyPolicy: "Politica sulla Privacy",
    terms: "Termini di Servizio",
    
    previous: "Precedente",
    next: "Successivo",
  },
  
  fr: {
    home: "Accueil",
    about: "À Propos",
    projects: "Projets",
    resources: "Ressources",
    contact: "Contact",
    docs: "Documentation",
    inviteManager: "Invite Manager",
    templateBot: "Template Bot",
    multipurposeBot: "Multipurpose Bot",
    connect: "Connecter",
    
    intro: "Développeur Frontend & Ingénieur",
    available: "Disponible",
    mainHeadline: "Construire Premium",
    typingEffect: "Expériences Numériques",
    subHeadline: "Spécialisé dans la création de bots Discord évolutifs, d'applications web modernes et de documentation technique complète.",
    viewProjects: "Voir les Projets",
    viewDocs: "Documentation",
    
    aboutTitle: "À Propos de Moi",
    aboutSubtitle: "Développeur, Ingénieur, Rédacteur de Documentation",
    
    projectsTitle: "Projets en Vedette",
    projectsSubtitle: "Bots et applications web prêts pour la production",
    
    resourcesTitle: "Ressources d'Apprentissage",
    resourcesSubtitle: "Guides et documentation sélectionnés",
    
    contactTitle: "Contact et Demandes",
    contactSubtitle: "Parlons de systèmes évolutifs, d'architecture de bots ou de café.",
    getInTouch: "Entrer en Contact",
    getInTouchDesc: "Je suis actuellement ouvert aux opportunités de Data Science, Backend Engineering ou Full-stack. Si vous avez des questions sur ma documentation ou souhaitez collaborer, n'hésitez pas à me contacter.",
    email: "Email",
    primaryContact: "Contact Principal",
    discord: "Discord",
    fastResponse: "Réponse Rapide",
    github: "GitHub",
    codebase: "Code Source",
    clickHere: "Cliquez Ici",
    
    copyrightText: "Créé avec React + Parcel. Tous Droits Réservés.",
    privacyPolicy: "Politique de Confidentialité",
    terms: "Conditions d'Utilisation",
    
    previous: "Précédent",
    next: "Suivant",
  },
  
  cn: {
    home: "主页",
    about: "关于",
    projects: "项目",
    resources: "资源",
    contact: "联系",
    docs: "文档",
    inviteManager: "邀请管理器",
    templateBot: "模板机器人",
    multipurposeBot: "多功能机器人",
    connect: "连接",
    
    intro: "前端开发者 & 工程师",
    available: "可用",
    mainHeadline: "构建优质",
    typingEffect: "数字体验",
    subHeadline: "专注于制作可扩展的Discord机器人、现代Web应用程序和全面的技术文档。",
    viewProjects: "查看项目",
    viewDocs: "文档",
    
    aboutTitle: "关于我",
    aboutSubtitle: "开发者、工程师、文档编写者",
    
    projectsTitle: "精选项目",
    projectsSubtitle: "生产就绪的机器人和Web应用",
    
    resourcesTitle: "学习资源",
    resourcesSubtitle: "精选指南和文档",
    
    contactTitle: "联系与咨询",
    contactSubtitle: "让我们讨论可扩展系统、机器人架构或咖啡。",
    getInTouch: "保持联系",
    getInTouchDesc: "我目前接受数据科学、后端工程或全栈开发的机会。如果您对我的文档有任何问题或想要合作，请随时联系我。",
    email: "邮箱",
    primaryContact: "主要联系方式",
    discord: "Discord",
    fastResponse: "快速响应",
    github: "GitHub",
    codebase: "代码库",
    clickHere: "点击这里",
    
    copyrightText: "使用 React + Parcel 构建。保留所有权利。",
    privacyPolicy: "隐私政策",
    terms: "服务条款",
    
    previous: "上一页",
    next: "下一页",
  },
  
  jp: {
    home: "ホーム",
    about: "について",
    projects: "プロジェクト",
    resources: "リソース",
    contact: "お問い合わせ",
    docs: "ドキュメント",
    inviteManager: "招待マネージャー",
    templateBot: "テンプレートBot",
    multipurposeBot: "多目的Bot",
    connect: "接続",
    
    intro: "フロントエンド開発者＆エンジニア",
    available: "利用可能",
    mainHeadline: "プレミアム構築",
    typingEffect: "デジタル体験",
    subHeadline: "スケーラブルなDiscordボット、最新のWebアプリケーション、包括的な技術文書の作成を専門としています。",
    viewProjects: "プロジェクトを見る",
    viewDocs: "ドキュメント",
    
    aboutTitle: "私について",
    aboutSubtitle: "開発者、エンジニア、ドキュメントライター",
    
    projectsTitle: "注目のプロジェクト",
    projectsSubtitle: "本番環境対応のボットとWebアプリ",
    
    resourcesTitle: "学習リソース",
    resourcesSubtitle: "厳選されたガイドとドキュメント",
    
    contactTitle: "お問い合わせ",
    contactSubtitle: "スケーラブルシステム、ボットアーキテクチャ、またはコーヒーについて話しましょう。",
    getInTouch: "連絡を取る",
    getInTouchDesc: "現在、データサイエンス、バックエンドエンジニアリング、またはフルスタック開発の機会を受け付けています。私のドキュメントに関する質問やコラボレーションをご希望の場合は、お気軽にお問い合わせください。",
    email: "メール",
    primaryContact: "主な連絡先",
    discord: "Discord",
    fastResponse: "迅速な対応",
    github: "GitHub",
    codebase: "コードベース",
    clickHere: "ここをクリック",
    
    copyrightText: "React + Parcelで構築。全著作権所有。",
    privacyPolicy: "プライバシーポリシー",
    terms: "利用規約",
    
    previous: "前へ",
    next: "次へ",
  },
};

export const t = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
